import { create } from 'zustand';

const useShareModalStore = create((set) => ({
  open: false,
  metadata: {},
  setOpen: (isOpen, metadata) =>
    set(() => ({ open: isOpen, metadata: metadata || {} })),
}));

export default useShareModalStore;
